module.exports = __webpack_public_path__ + "static/media/lamungamap.24979811.png";